import React, { useContext, useEffect, useState } from "react";

import "../../index.scss";
import "./style.modules.scss";

import { useHistory } from "react-router-dom";

import { evaluationTypes } from "../../NodeTypes";

import { useNodesTree } from "containers/PeopleCraft/LearningManagementNew/Components/NodesTree/hooks/useNodesTree";

import ModalDialog from "../../../Modals/ModalDialog";

import { statusTypes } from "containers/PeopleCraft/ContentPage/StatusTypes";

import { getMenuData } from "../../../../../services/NexiDigitalAPI";

import { PreTestCard } from "../../ContentTypes/PreTestCard";

export const PreTestKnowledgeCard = React.memo(
  ({
    elementItem,
    removeNode,
    loadingDeleteBlockElement,
    permissionLearningPage,
    blockData,
    nodeData,
  }) => {
    const history = useHistory();
    const { nodeSelectItem } = useNodesTree();

    const [currentElement, setCurrentElement] = useState(null);
    const [showEditRedirect, setShowEditRedirect] = useState(false);

    const callEditElement = (elementItem) => {
      const { data } = elementItem;
      const evaluationBase = evaluationTypes[data.evaluationType]; // REACTION, knowledge
      history.push(`/${evaluationBase.url}/${blockData?.idBlock}/${elementItem.idElement}/1`);
    };

    const noEditPermition = (elementItem, nodeData) => {
      const { idCompany } = getMenuData();
      const redirectFromOutsideCompany =
        nodeData.usedAsRedirect === 1 && nodeData.idCompany !== idCompany;
      const contentEditable =
        elementItem.data.contentEditable === true || elementItem.data.contentEditable === null
          ? true
          : false;

      if (contentEditable === false) {
        return true;
      } else {
        return (
          ([statusTypes.ARCHIVED, statusTypes.PUBLISHED].includes(nodeData?.status) &&
            elementItem.elementType !== "IMAGE") ||
          !permissionLearningPage ||
          redirectFromOutsideCompany
        );
      }
    };

    return (
      <div>
        <div className="node-manager-content-item-wrapper-v2" style={{ boxShadow: "none" }}>
          <ModalDialog
            title={currentElement ? currentElement.title : ""}
            text={currentElement ? currentElement.text : ""}
            show={showEditRedirect}
            setShow={setShowEditRedirect}
            btnCall={{
              className: "",
              variantBtn: "warning",
              text: "Sim, alterar em todos os locais.",
              callEvent: () => {
                nodeSelectItem(currentElement.elementItem.data);
              },
            }}
          />
          <div className="node-manager-node-item-content-v2">
            <PreTestCard
              element={elementItem}
              permissionLearningPage={permissionLearningPage}
              idBlock={blockData.idBlock}
              noEditPermition={noEditPermition}
              handleEditElementRedirect={callEditElement}
              removeNode={removeNode}
              loadingDeleteBlockElement={loadingDeleteBlockElement}
            />
          </div>
        </div>
      </div>
    );
  },
);
